import React, { useCallback, useState } from 'react';
import { Flex, Stack, Switch, Text, Textarea, Radio } from '@mantine/core';
import { change, Field } from 'redux-form';
import Button from '../../elements/Button';
import { btnTextSubmit, labelText, placeholderText } from './constants';
import PropTypes from 'prop-types';
import ImagePicker from '../../elements/ImagePicker';
import { MIME_TYPES } from '@mantine/dropzone';
import { useDispatch, useSelector } from 'react-redux';

const FormCreateUpdateReason = ({
  type,
  onClose,
  // handleSubmit,
  handleSubmitReason,
  invalid,
  // data = {}
}) => {
  const { values, initial } = useSelector((state) => state.form.formCreateUpdateReason);
  const [file, setFile] = useState(initial?.supportDocument);

  const dispatch = useDispatch();

  const renderTextarea = useCallback(({ input, meta }) => (
    <div>
      <Textarea
        {...input}
        error={(meta.touched) && meta.error}
        label={labelText[type]}
        minRows={4}
        placeholder={placeholderText[type] || ''}
      />
      {(type === 'createReasonDetail' || type === 'updateReasonDetail')
        && <Text c="#52575C" fw={400} fz={14}>Keterangan yang akan muncul ketika NIK terblokir melakukan transaksi atau pendafaran</Text>}
    </div>
  ), [type]);

  const renderSwitch = useCallback(({ input }) => (
    <Switch
      checked={!!input.value}
      label={input.value ? 'Aktif' : 'Tidak Aktif'}
      onChange={input.onChange}
      styles={{ label: { fontWeight: 400 } }}
    />
  ), []);

  const renderRequestUnblockRadios = useCallback(({ input, meta }) => {
    const optionStyle = {
      border: '1px solid #E6E8EC',
      borderRadius: 8,
      padding: '12px 14px',
      display: 'flex',
      alignItems: 'center'
    };

    return (
      <div>
        <Text c="#25282B" fw={600}>Kelayakan Buka Blokir</Text>
        <Radio.Group
          onChange={input.onChange}
          value={input.value}
        >
          <div style={{ ...optionStyle, marginBottom: '1rem' }}>
            <Radio label="Dapat buka blokir" styles={{
              label: {
                fontWeight: 400
              }
            }} value="true" />
          </div>
          <div style={optionStyle}>
            <Radio label="Tidak dapat buka blokir" styles={{
              label: {
                fontWeight: 400
              }
            }} value="false" />
          </div>
        </Radio.Group>
        {meta.touched && meta.error && <Text c="red">{meta.error}</Text>}
        <Text c="#52575C" fw={400} fz={14}>Pilih apakah pelanggan dapat mengajukan buka blokir atau tidak</Text>
      </div>
    );
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmitReason({
      ...values, supportDocument: file
    });
  };
  const isReasonType = ['createReason', 'updateReason']?.includes(type);

  return (
    <form onSubmit={onSubmit}>
      <Stack>
        <Field
          component={renderTextarea}
          name="reason"
        />
        {isReasonType && <Field
          component={renderRequestUnblockRadios}
          format={(val) => { if (val === true) return 'true'; if (val === false) return 'false'; return ''; }}
          name="isRequestUnblock"
          parse={(val) => { if (val === 'true') return true; if (val === 'false') return false; return undefined; }}
        />}
        {isReasonType && <ImagePicker
          accept={[MIME_TYPES.pdf]}
          defaultValue={initial?.supportDocument}
          info={'Dokumen pendukung yang diunggah berisi dasar kebijakan dilakukannya blokir NIK dan harus dalam format PDF.'}
          maxSize={2000000}
          onSelect={(file) => {
            dispatch(change('formCreateUpdateReason', 'isAttachFile', true));
            setFile(file);
          }}
          required={true}
          title={'Dokumen Pendukung'}
        />}
        <Field
          component={renderSwitch}
          id="switchReasonStatus"
          name="isActive"
        />
        <Text fz="sm">
          Aktifkan status untuk menampilkan alasan blokir di formulir <b>Blokir NIK Pelanggan</b>
        </Text>
        <Flex align="center" gap="sm" justify="center">
          <Button fullWidth onClick={onClose} style="outlined" type="button">Batal</Button>
          <Button disabled={invalid || (file.length < 1 && isReasonType) && true} fullWidth type="submit">{btnTextSubmit[type]}</Button>
        </Flex>
      </Stack>
    </form>
  );
};

export default FormCreateUpdateReason;

FormCreateUpdateReason.propTypes = {
  data: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleSubmitReason: PropTypes.func,
  invalid: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['createReason', 'updateReason', 'createReasonDetail', 'updateReasonDetail'])
};
